var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"no-icon"},[_vm._v(" Test... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }